import { SetState } from 'zustand';
import { CommonMarketingQueryState } from 'stores/interfaces/CommonQueryState';

export const commonMarketingQueryInitialStateFields = {
  account: undefined,
  fileName: undefined
};

export const commonMarketingQueryInitialState = {
  ...commonMarketingQueryInitialStateFields,
  fetching: false
};

export const createCommonMarketingQuerySlice = <T extends CommonMarketingQueryState>(
  set: SetState<T>
) => ({
  ...commonMarketingQueryInitialState,
  setAccount: (value?: string) => set(() => ({ account: value })),
  setFileName: (value?: string) => set(() => ({ fileName: value })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () =>
    set({
      account: '',
      fileName: ''
    })
});
